export default {
    productParentList: [],
    productParentItem: null,
    params: {
        paginate: true,
        page: 1,
        perPage: 30,
        filter: "",
        line_id: ""
    },
    pagination: {
        data: [],
        from: 0,
        to: 0,
        total: 0
    },
    imagesColor: [],
    dataSheetsLineArr: []
};



// WEBPACK FOOTER //
// ./src/modules/product-parent/state.js